import useAppStore from "@/Modules/App/Store";

import type { TherapistStore } from "@/Modules/Therapist/Store";
import type { AppStore } from "@/Modules/App/Store";
import type { TherapistUpdateEducationApiQuery } from "@/Modules/Models/Api/Therapist";
import type { TherapistEducation } from "@/Modules/Models/Domain/Therapist";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import TherapistApiConnector from "@/Services/TherapyApi/Therapists";

class UpdateEducationActionHandler {
  constructor(
    private readonly therapistStore: TherapistStore,
    private readonly appStore: AppStore = useAppStore(),
    private readonly therapistApiConnector = new TherapistApiConnector()
  ) {}

  public async handle(updateEducationQuery: TherapistUpdateEducationApiQuery) {
    try {
      this.therapistStore.isLoading = true;

      await this.therapistApiConnector.updateTherapistEducation(updateEducationQuery);

      if (this.therapistStore.therapist?.educations.length) {
        const updatedEducation: TherapistEducation = {
          uuid: updateEducationQuery.uuid,
          title: updateEducationQuery.title,
          institution: updateEducationQuery.institution,
        };

        const updatedEducations: TherapistEducation[] = this.therapistStore.therapist?.educations.map(
          (education) => (education.uuid === updatedEducation.uuid ? { ...updatedEducation } : education)
        );

        this.therapistStore.therapist.educations = updatedEducations;
      }

      this.appStore.showSnackbar({
        type: NotificationType.SUCCESS,
        message: "settings.configuration.educations.notification.edit.success",
      });
    } catch (error: unknown) {
      this.appStore.showSnackbar({
        type: NotificationType.ERROR,
        message: "settings.configuration.educations.notification.error",
      });
    } finally {
      this.therapistStore.isLoading = false;
    }
  }
}

export default UpdateEducationActionHandler;
